import React from 'react';

export default function CookiePolicy() {
  return (
    <div className="pt-16">
      {/* Header Section */}
      <div className="bg-gradient-to-br from-blue-900 via-blue-800 to-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-center">
          <h1 className="text-5xl font-extrabold mb-4">Cookie Policy</h1>
          <p className="text-blue-100 text-lg">Last updated: January 30, 2025</p>
        </div>
      </div>

      {/* Main Content Section */}
      <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-10 py-16">
        <div className="prose prose-lg max-w-none leading-relaxed">
          <p className="text-gray-700 text-lg">
            This Cookie Policy explains how <strong>UCX</strong> uses cookies and similar tracking technologies when you visit our website. We aim to be transparent about what information we collect, why we collect it, and how you can manage your preferences.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8">Third-Party Services</h2>
          <p>
            We use the following third-party services that may collect information through cookies:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Google Analytics:</strong> Tracks website usage and performance metrics to help us improve our services.</li>
            <li><strong>Google Tag Manager:</strong> Manages and deploys tracking codes and marketing tags on our website.</li>
            <li><strong>Formspree:</strong> Handles contact form submissions securely.</li>
          </ul>
          <p>
            These services have their own privacy policies and cookie practices. We recommend reviewing their policies for more information about how they handle your data.
          </p>
          
          <h2 className="text-2xl font-semibold mt-8">What Are Cookies?</h2>
          <p>
            Cookies are small text files that are stored on your device (computer, tablet, or mobile) when you visit a website. They help websites function properly, improve user experience, and provide analytical insights.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Types of Cookies We Use</h2>
          <p>We use various types of cookies to enhance your browsing experience and gather valuable insights:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Essential Cookies:</strong> Required for basic website functionality, such as security and accessibility.</li>
            <li><strong>Performance Cookies:</strong> Collect anonymous data about how users interact with our website to optimize functionality.</li>
            <li><strong>Analytics Cookies:</strong> Provide insights into user behavior to improve website performance and content.</li>
            <li><strong>Functionality Cookies:</strong> Remember your preferences, such as language and location settings.</li>
            <li><strong>Marketing Cookies:</strong> Track browsing habits to deliver personalized advertisements and promotions.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">How We Use Cookies</h2>
          <p>
            Our use of cookies falls into the following categories:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Authentication & Security:</strong> Verify user identity and protect against fraud.</li>
            <li><strong>Performance & Analytics:</strong> Monitor website traffic and improve the user experience.</li>
            <li><strong>Personalization:</strong> Customize content based on user preferences and behavior.</li>
            <li><strong>Marketing & Advertising:</strong> Display relevant ads based on browsing activity.</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8">Managing Your Cookie Preferences</h2>
          <p>
            You have control over your cookie settings and can manage them in the following ways:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Adjust your browser settings to accept, block, or delete cookies.</li>
            <li>Use cookie management tools provided by third parties.</li>
            <li>Opt-out of certain cookies, such as tracking or targeted advertising, via industry-standard opt-out mechanisms.</li>
          </ul>
          <p>
            Please note that disabling certain cookies may impact your experience on our website and limit some of its functionalities.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Third-Party Cookies</h2>
          <p>
            We may partner with third-party services that use cookies for analytics, advertising, and functionality purposes. These third-party providers have their own privacy and cookie policies, which govern their data collection and processing.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Data Retention & Privacy</h2>
          <p>
            The information collected through cookies is stored securely and retained only for as long as necessary to fulfill its intended purpose. We adhere to strict privacy guidelines to ensure data protection and compliance with relevant regulations.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Updates to This Policy</h2>
          <p>
            We reserve the right to update this Cookie Policy periodically to reflect changes in technology, legal requirements, or our business practices. Any updates will be posted on this page with a revised date.
          </p>

          <h2 className="text-2xl font-semibold mt-8">Contact Us</h2>
          <p>
            If you have any questions or concerns about our use of cookies, please reach out to us:
          </p>
          <ul className="list-none space-y-2">
            <li><strong>Email:</strong> <a href="mailto:privacy@ucx.co" className="text-blue-600 hover:underline">privacy@ucx.co</a></li>
            <li><strong>Phone:</strong> <a href="tel:+18442193935" className="text-blue-600 hover:underline">844-219-3935</a></li>
            <li><strong>Address:</strong> 1348 Hwy 287, Suite 300, Waxahachie, TX 75165</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
